import { flow } from 'fp-ts/function';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { AccountFile } from '@mews-commander/data-access';
import { ApplicationState, WithOwnerId } from '@mews-commander/types';
import { mapId, sortByDescending } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors, Entities } from './utils';

export const NAME = 'files';

export const FILES_LOADED = prefix('FILES_LOADED');
export const FILE_ADD = prefix('FILE_ADD');
export const [FILE_ADD_STARTED, FILE_ADD_SUCCEEDED, FILE_ADD_FAILED] = createAsyncActionTypes(FILE_ADD);
export const FILE_DELETE = prefix('FILE_DELETE');
export const [FILE_DELETE_STARTED, FILE_DELETE_SUCCEEDED, FILE_DELETE_FAILED] = createAsyncActionTypes(FILE_DELETE);
export const FILE_UPDATE = prefix('FILE_UPDATE');
export const [FILE_UPDATE_STARTED, FILE_UPDATE_SUCCEEDED, FILE_UPDATE_FAILED] = createAsyncActionTypes(FILE_UPDATE);

export const setFiles = (files: Entities<AccountFile>, ownerId: string) =>
    createAction(FILES_LOADED, { entities: files, ownerId });

export const filesReducer = createEntitiesReducer({
    FETCH_SUCCESS: FILES_LOADED,
    ADD_SUCCESS: FILE_ADD_SUCCEEDED,
    DELETE_SUCCESS: FILE_DELETE_SUCCEEDED,
    UPDATE_SUCCESS: FILE_UPDATE_SUCCEEDED,
});

export const [getFiles, getFilesByIds, getFilesByOwnerId, getFile] = createBaseEntitySelectors<
    ApplicationState,
    AccountFile & WithOwnerId,
    typeof NAME
>(parentSelector, NAME);

export const getOwnerSortedFilesIds = flow(getFilesByOwnerId, sortByDescending('createdUtc'), mapId);
